export default {
  sizes: ["Бит", "КБ", "МБ", "ГБ", "ТБ", "ПБ"],
  uploadNoMoreFiles: "Ең көп дегенде {maxFileCount} файл жүктеңіз",
  maxFileSize: {
    upppercase: " {maxFileSize} дейін",
    lowercase: "{maxFileSize} дейін",
  },
  maxUploadFilesAmountWithSize:
    "әрқайсысы {maxFileSize} дейін {maxFilesAmount} файлға дейін",
  minMaxUploadFilesAmountWithSize:
    "әрқайсысы {size}-дан аспайтын {from}-ден {to}-ге дейін файл",
  oneUploadFileWithMaxsize: "1 файл {maxFileSize} дейін",
  newFileAction: {
    moveOr: "Файлды сүйреңіз немесе",
    upload: "жүктеңіз",
  },
  validation: {
    maxSize: "Файлдың ең үлкен көлемі асырылды",
    unsupportedFileType: "Қолдау көрсетілмейтін файл пішімі",
    addedUnsupportedFiles: "Қолдау көрсетілмейтін файлдар қосылды",
    totalSizeNotMoreThan: "Файлдардың жалпы көлемі {totalSize}-дан аспауы тиіс",
    exceedFilesAmountLimit: "Жүктелетін файлдар санының шектеуі асырылды",
  },
  uploadPhoto: "Фотосурет жүктеу",
  photoAspect: "Суреттің жақтарының арақатынасы — {aspect}",
  pictureEditing: "Суреттерді өңдеу",
  selectedAreaWillDisplay:
    "Таңдалған аймақ сіздің мекемеңізді RC PAY-де қарағанда көрсетіледі.",
};
